import {
  useAutocompleteSource,
  FileRef,
  abortableFetch,
  ApiFilterOperation,
  useStaticListSource,
  DictionaryAutocomplete,
} from '@eas/common-web';
import { UFormAutocomplete, UForm } from '../../models';
import { EvidenceAPI } from '../../enums';

export function useUFormStates() {
  return useStaticListSource<DictionaryAutocomplete>([
    { id: 'READY_TO_SEND', name: 'Připraveno k odeslání' },
    { id: 'AUTHORIZED', name: 'Autorizováno přes NIA' },
    { id: 'SUBMITTED', name: 'Podáno na MŽP' },
  ]);
}

export function useDictionaryForm() {
  return useAutocompleteSource<UFormAutocomplete>({
    url: `${EvidenceAPI.UFORM}/list`,
  });
}

export function createAttachment(values: {
  form: UForm;
  file: FileRef;
  order: number;
}) {
  return abortableFetch(`${EvidenceAPI.UFORM}/attachment`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(values),
  });
}

export function listAttachments(formId: string) {
  return abortableFetch(`${EvidenceAPI.UFORM}/attachment/list`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({
      filters: [
        {
          field: 'uFormId',
          operation: ApiFilterOperation.EQ,
          value: formId,
        },
      ],
    }),
  });
}

export function sendUForm(id: string, using: 'ISDS' | 'ESSL' = 'ISDS') {
  return abortableFetch(
    `${EvidenceAPI.UFORM}/${id}/send?using=${using}&async=true`,
    {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    }
  ).response;
}
